import React from 'react';
import Image from 'next/image';
import { Card, CardContent } from '@lb-service/ui';
import { useTranslation } from 'next-i18next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import SectionIntro from '../../molecules/SectionIntro';

const CoursesAbout = () => {
  const { t } = useTranslation('common');
  return (
    <Card className="bg-slate-50 border-0 shadow-none rounded-none">
      <CardContent>
        <div id="courses-about-container">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8">
            <SectionIntro
              title={t('service.courses.aboutLingualBox.title')}
              intro={t('service.courses.aboutLingualBox.intro')}
            />
            <div className="section-content mt-16 mb-24">
              <div className="grid grid-cols-12 gap-8">
                <div className="col-span-12 lg:col-span-6 md:col-span-6 sm-center">
                  <div className="mb-8">
                    <Image
                      width={588}
                      height={400}
                      className="how-it-works__photo"
                      src="/images/quality_instructor.jpg"
                      alt="Tutoring Image"
                    />
                  </div>
                </div>
                <div className="col-span-12 lg:col-span-6 md:col-span-6 sm-center">
                  <div className="mb-8 sm-center">
                    <h3 className="text-lg">
                      {t('service.courses.aboutLingualBox.oneToOne.title')}
                    </h3>
                    <p>{t('service.courses.aboutLingualBox.oneToOne.intro')}</p>
                  </div>
                  <div className="mb-8 sm-center">
                    <h3 className="text-lg">
                      {t('service.courses.aboutLingualBox.anytime.title')}
                    </h3>
                    <p>{t('service.courses.aboutLingualBox.anytime.intro')}</p>
                  </div>
                  <div className="mb-8 sm-center">
                    <h3 className="text-lg">
                      {t('service.courses.aboutLingualBox.tutors.title')}
                    </h3>
                    <p>{t('service.courses.aboutLingualBox.tutors.intro')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, ['common'])),
  },
});

export default CoursesAbout;
